var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-form',_vm._b({ref:"form",attrs:{"title":"Datos de reenvasado"},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}},'model-form',_vm.formProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }